import React, { useState } from "react";

import { Button, Grid, IconButton, TextField } from "@material-ui/core";
import {
  AddCircle as AddCircleIcon,
  Delete as DeleteIcon,
  CloudUpload as CloudUpload
} from "@material-ui/icons";

export default function Inputs({ form: { getFieldDecorator }, inputs }) {
  
  const [inputsForm, setInputs] = useState([...inputs]);

  const handlePlus = () => {
    setInputs(inputsForm => [...inputsForm, {input: {url: '', reason: ''}}]);
  };

  const handleTrash = index => {
    const newInputs = [...inputsForm];
    newInputs.splice(index, 1);
    setInputs(inputsForm => [...newInputs]);
  };

  const handleFileInput = (e) => {
    const reader = new FileReader();
    const inputs = {};
    reader.onloadend = async (e) => {
      e.target.result.split(/\r\n|\r|\n/).forEach((input) => {
        if (inputs[input.split(',')[1]] === undefined) {
          inputs[input.split(',')[1]] = [input.split(',')[0]];
        } else {
          inputs[input.split(',')[1]].push(input.split(',')[0]);
        }
      });
      delete inputs.undefined;
      setInputs([]);
      for (const [reason, urls] of Object.entries(inputs)) {
        setInputs(inputsForm => [...inputsForm, {input: {url: urls.join('\n'), reason: reason}}]);
      }
    };
    reader.readAsText(e.target.files[0]);
  };

  return (
    <>
      <Grid spacing={1} container item xs={12} justify="flex-end">
        <Button
          variant="contained"
          component="label"
          style={{ marginTop: 20, marginRight: 10, width: "40%" }}
          color="primary"
          variant="outlined"
          startIcon={<CloudUpload/>}
        >
          Import from file
          <input
              id="file"
              type="file"
              hidden
              onChange={handleFileInput}
          />
        </Button>
        <Button
          style={{ marginTop: 20, width: "30%" }}
          color="primary"
          variant="outlined"
          startIcon={<AddCircleIcon />}
          onClick={handlePlus}
        >
          Add others
        </Button>
      </Grid>
      {inputsForm.map((input, index) => (
        <div key={index}>
          <Grid spacing={1} container item xs={12}>
          <Grid item xs={10}>
              {getFieldDecorator(`reason[${index}]`, {
                initialValue: input.input.reason ? input.input.reason.toString() : "",
                rules: [
                  {
                    required: true,
                    message: "Please input your reason!",
                    whitespace: true,
                  },
                ],
              })(
                <TextField
                  id="reason"
                  label="reason"
                  color="primary"
                  fullWidth
                  style={{ marginTop: 13 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  placeholder="reason"
                />,
              )}
            </Grid>

            <Grid item xs={10}>
              {getFieldDecorator(`url[${index}]`, {
                initialValue: input.input.url ? input.input.url.toString() : "",
                rules: [
                  {
                    required: true,
                    message: "Please input your url!",
                    whitespace: true,
                  },
                ],
              })(
                <TextField
                  id="url"
                  label="URLs"
                  multiline
                  rows={5}
                  variant="outlined"
                  color="primary"
                  fullWidth
                  style={{ marginTop: 10, marginBottom: 13 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />,
              )}
            </Grid>

            <Grid item xs={2}>
              {inputsForm.length !== 1 && (
                <IconButton
                  aria-label="delete"
                  style={{ width: "100%" }}
                  onClick={() => handleTrash(index)}
                >
                  <DeleteIcon color="primary" />
                </IconButton>
              )}
            </Grid>
          </Grid>
        </div>
      ))}
    </>
  );
}